import { render, staticRenderFns } from "./TenantUpdate.vue?vue&type=template&id=3d74f4b3&scoped=true"
import script from "./TenantUpdate.vue?vue&type=script&lang=js"
export * from "./TenantUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d74f4b3",
  null
  
)

export default component.exports